module.exports = __webpack_public_path__ + "static/img/Converse-Zeichen-2003-2007-650x366.d9a75513.jpg";